export default function (input) {
    var cvrNumber = Number(input)

    // Check if the conversion was successful and if the input length is 8
    return !isNaN(cvrNumber) && input.length === 8
}
